import {makeFetchTransport, makeMultiplexedTransport} from '@sentry/vue';
import type {BrowserOptions} from '@sentry/vue';

/**
 * Feeds error events to a second Sentry-compatible DSN while the Better Stack migration runs. The
 * matcher matches error envelopes only, so replays, transactions and sessions stay with the primary.
 */
export function createDualFeedTransport(
    dsn: string | undefined,
    secondaryDsn: string | undefined
): BrowserOptions['transport'] {
    if (!dsn || !secondaryDsn) {
        return undefined;
    }

    return makeMultiplexedTransport(makeFetchTransport, ({getEvent}) =>
        getEvent() ? [dsn, secondaryDsn] : []
    );
}
